
























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { DELETE_API } from '@/store/types';
import { API } from '@/store/apis/models';
import { namespaces } from '@/scripts/namespaces';

@Component
export default class DeleteAPI extends Vue {
  // Props
  @Prop() api!: API;

  // Actions
  @Action(DELETE_API, { namespace: namespaces.API }) deleteApi: any;

  // Data
  private dialog = false;

  private deleteLoading = false;

  private workspaceId: string = this.$route.params.workspaceId;

  // Methods
  /**
   * Removes the API from the workspace
   */
  async removeApi() {
    this.deleteLoading = true;

    try {
      await this.deleteApi({
        workspaceId: this.workspaceId,
        apiId: this.api.id,
      });
      this.deleteLoading = false;
      this.dialog = false;
    } catch (error) {
      this.deleteLoading = false;
    }
  }
}
